import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	onChange: (value: string) => void;
	setId: string;
}

export const RecipientBank: React.FC<IProps> = React.memo(({ onChange, setId }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterRecipientBank') }], [t]);

	return (
		<FormInput
			testId="RecipientBank"
			name={`recipientBank-${setId}`}
			label="recipientBankLabel"
			onChange={onChange}
			validationRules={validationRules}
			maxLength={160}
		/>
	);
});
